import { useMemo } from "react";

import Liferay from "../utils/Liferay";

/**
 * Hook personalizado para formatear fechas según la configuración regional de Liferay.
 *
 * @returns {object} Un objeto que contiene la función formatDate.
 */
function useDateFormatter() {

  /**
   * Obtiene el identificador de idioma configurado en Liferay y lo convierte al formato adecuado.
   *
   * @returns {string} El identificador de idioma en formato "lang-REGION".
   */
  const locale = useMemo(() => Liferay.ThemeDisplay.getLanguageId().replace("_", "-"), []);

  /**
   * Crea un formateador de fechas basado en la configuración regional.
   *
   * @returns {Intl.DateTimeFormat} Un objeto Intl.DateTimeFormat configurado.
   */
  const dateFormatter = useMemo(
    () => new Intl.DateTimeFormat(locale, {
      month: "long",
      day: "numeric",
      weekday: "long",
    }),
    [locale],
  );

  /**
   * Formatea una fecha según la configuración regional.
   *
   * @param {Date} date - La fecha a formatear.
   *
   * @returns {string} La fecha formateada.
   */
  function formatDate(date) {

    const formattedDate = dateFormatter.format(date);

    return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);

  }

  return { formatDate };

}

export default useDateFormatter;
